import HttpService from "./htttp.service";

class DepartmentsService {
  getDepartments = async (query, cancelToken) => {
    const endpoint = "departments";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createDepartment = async (payload) => {
    const endpoint = "departments";
    return await HttpService.post(endpoint, payload);
  };

  removeDepartment = async (id) => {
    const endpoint = "departments/" + id;
    return await HttpService.delete(endpoint, id);
  };

  updateDepartment = async (id, payload) => {
    const endpoint = "departments/" + id;
    return await HttpService.put(endpoint, payload);
  };
}

export default new DepartmentsService();
